import React, { FC } from 'react';
// Styles
import styles from './usersidebar.module.scss';
// Interfaces
import { Sidebar } from '../..';

interface IUserSidebarProps {
    isEmpty?: boolean;
    children?: React.ReactNode;
}

export const UserSidebar: FC<IUserSidebarProps> = ({ isEmpty, children }) => {
    return (
        <Sidebar isEmpty={isEmpty}>
            <div className={`styleless ${styles.emptyDiv}`} />
            {children}
        </Sidebar>
    );
};
